var MAX_PRECISION = 20;
export default function round(value, precision) {
  var result = value;
  var decimals = precision || 0;
  result = result.toString().split('e');
  result = Math.round(Number(result[0] + 'e' + (result[1] ? Number(result[1]) + decimals : decimals)));
  result = result.toString().split('e');
  result = Number(result[0] + 'e' + (result[1] ? Number(result[1]) - decimals : -decimals));
  return result.toFixed(Math.min(decimals, MAX_PRECISION));
}